<template>
  <div class="cost-breakdown">
    <div class="cost-breakdown-body">
      <div ref="searchBox" class="formBox margbot">
        <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="90px" size="mini">
          <div class="formItemBox">
          <el-form-item label="业务时间:">
            <div style="display: flex;">
            <el-date-picker v-model="formData.businessTimeStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker> ~
            <el-date-picker v-model="formData.businessTimeEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="业务类型:">
            <el-select v-model="formData.businessType" size="mini" placeholder="请选择" filterable clearable>
              <el-option v-for="(item,index) in YwTypeOptions" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算客户:">
            <el-select v-model="formData.payCustomerName" size="mini" placeholder="请选择" filterable clearable>
              <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.showName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态:">
            <el-select v-model="formData.feeStatus" size="mini" placeholder="请选择" filterable clearable>
              <el-option v-for="(item, index) in jiesuanOptions" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务单号:">
            <el-input v-model="formData.businessNo" placeholder="请输入" size="mini" ></el-input>
          </el-form-item>
          <el-form-item label="货物类型:">
            <el-select v-model="formData.productTypeName" @change="productTypeChange" clearable placeholder="请选择" filterable >
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productTypeName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:">
            <el-select v-model="formData.steelMillName" @change="steelMillNameChange" clearable placeholder="请选择" filterable >
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:">
            <el-select v-model="formData.specification" @change="specificationChange" clearable placeholder="请选择" filterable >
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:">
            <el-select v-model="formData.model" clearable @change='modelChange' placeholder="请选择" filterable >
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="一级货主:">
            <el-select v-model="formData.primaryCustomerName" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.custerName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级货主:">
            <el-select v-model="formData.customerName" size="mini" placeholder="请选择货主" filterable clearable>
              <el-option v-for="(item, index) in RKData" :key="index" :label="item.custerName" :value="item.custerName">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[6]">查询</el-button>
            <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[7]">重置</el-button>
            <el-button type="primary" size="mini" @click="daochu" v-if="btnFlg[8]">导出</el-button>
            <el-button type="primary" size="mini" @click="changeCustomer" v-if="btnFlg[9]">修改结算客户</el-button>
            <span style="margin-left:10px">总件数：<span style="color:red">{{ AllNumber }}</span> 件</span>
            <span style="margin-left:10px">总重量：<span style="color:red">{{ AllWeight }}</span> 吨</span>
            <span style="margin-left:10px">费用合计：<span style="color:red">{{ AllFeeAmount }}</span> 元</span>
          </el-form-item>
        </el-form>
      </div>
      <!-- 表格 -->
      <div :style="{ height: h }">
        <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @select="selectionChange">
          <el-table-column type="selection" align="center" width="40"></el-table-column>
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <!-- <el-table-column :show-overflow-tooltip="true" v-for="item in titleList" :key="item.titleName" :prop="item.titleId instanceof Array ?'':item.titleId" :label="item.titleName" align="center" :width="item.titleId=='customerName'||item.titleId=='cargoBarcode'||item.titleId=='payCustomerName'||item.titleId=='outstockNo'||item.titleId=='instockDate'||item.titleId=='outstockDate'||item.titleId=='contractNumber'||item.titleId=='agreementNumber'||item.titleId=='inCustomerName'?220:120">
            <template v-if="item.titleId instanceof Array ? true : false">
              <el-table-column v-for="i in item.titleId" :key="i.titleId" :prop="i.titleId" :label="i.titleName"></el-table-column>
            </template>
          </el-table-column> -->
          <el-table-column :show-overflow-tooltip="true" prop="payCustomerName" label="结算客户" align="center" width="200">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="80">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="80">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="100">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="100">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="50">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="总重量(吨)" align="center" width="100">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeType" label="费用类型" align="center" width="80">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价" align="center" width="50">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeAmount" label="金额" align="center" width="80">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeStatus" label="结算状态" align="center" width="80">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center" width="200"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="200">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车牌号" align="center" width="100">
          </el-table-column>
          <div v-if="chaoqiFlag==1">

            <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="outstockDate" label="出库日期" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="stockDate" label="库存天数" align="center" width="80">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="overdueDate" label="超期天数" align="center" width="80">
            </el-table-column>
          </div>
          <el-table-column :show-overflow-tooltip="true" prop="businessType" label="业务类型" align="center" width="80">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="业务单号" align="center" width="240">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="businessTime" label="业务时间" align="center" width="180">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="inRansportMethod" label="到货方式" align="center" width="80"></el-table-column>
        </el-table>
      </div>
      <div class="pags" style="text-align: right">
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="修改结算客户" :visible.sync="XGvisible" :close-on-click-modal="false" @close="XGvisible=false" width="40%" center>
      <!--form表单-->
      <el-form :model="KHFormData" ref="KHFormData" label-width="100px" class="demo-dynamic" style="width:350px;margin:30px auto;">
        <el-form-item label="结算客户:" :rules="[
              { required: true, message: '请选择结算客户', trigger: 'change' },
            ]">
          <el-select v-model="KHFormData.payCustomerName" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.showName">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="XGvisible = false">取 消</el-button>
        <el-button type="primary" @click="XGQD()" :loading="addLoad">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  zidian,
  getJCFeeAllfee,
  getJCFeeList,
  getVirtualBalingList,
  getRelationCustomer,
  getDictionaryJson,
  updateJCPayCustomer
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getBtn
} from '@/utils/getButton'

import {
  getQueryCusterData // 客户
} from '@/api/platform-settlement'

export default {
  name: 'costBreakdown',
  data () {
    return {
      formData: {
        businessTimeStart: '',
        businessTimeEnd: '',
        businessType: '',
        feeStatus: '1',
        payCustomerName: '',
        businessNo: '',
        productTypeName: '',
        steelMillName: '',
        specification: '',
        model: '',
        primaryCustomerName: '',
        customerName: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      jiesuanOptions: [{
        id: '',
        name: '全部'
      },
      {
        id: '1',
        name: '未收款'
      },
      {
        id: '2',
        name: '已收款'
      }
      ],
      YwTypeOptions: [{
        id: '1',
        name: '入库'
      },
      {
        id: '2',
        name: '出库'
      },
      {
        id: '3',
        name: '转货'
      },
      {
        id: '4',
        name: '钢厂转货'
      }
      ],
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      tableData: [],
      h: '500px',
      chaoqiFlag: 0,
      total: 0,
      AllWeight: 0,
      AllNumber: 0,
      AllFeeAmount: 0,
      keHuOptions: [],
      btnFlg: [],
      btnIdArr: ['003P01dB001', '003P01dB002', '003P01dB003', '003M310100', '003M310200', '003M310300', '003M310400',
        '003M310500', '003M310600', '003M310700'
      ],
      RKData: [],
      XGvisible: false,
      KHFormData: {
        payCustomerName: ''
      },
      selectionList: [],
      addLoad: false
    }
  },
  methods: {
    selectionChange (selection, row) {
      console.log(selection, row)
      this.selectionList = selection
    },
    chaxun () {
      delete this.formData.productType
      getJCFeeList({
        ...this.formData,
        ...this.pageInfo
      })
        .then(res => {
          this.tableData = res.list
          this.total = res.total
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
      getJCFeeAllfee({
        ...this.formData
      })
        .then(res => {
          this.AllWeight = res.AllWeight
          this.AllNumber = res.AllNumber
          this.AllFeeAmount = res.AllFeeAmount
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },

    chongzhi () {
      this.formData.businessTimeStart = ''
      this.formData.businessTimeEnd = ''
      this.formData.businessType = ''
      this.formData.payCustomerName = ''
      this.formData.feeStatus = '1'
      this.formData.businessNo = ''
      this.formData.productTypeName = ''
      this.formData.steelMillName = ''
      this.formData.specification = ''
      this.formData.model = ''
      this.formData.primaryCustomerName = ''
      this.formData.customerName = ''
      this.chaxun()
      this.getVirtualBalingList()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/storageFee/exportJCFeeList', {
          ...this.formData
        },
        '费用明细'
      )
    },
    changeCustomer () {
      if (this.selectionList.length == 0) {
        this.$message.error('请选择要修改的结算客户')
      } else {
        for (let i = 0; i < this.selectionList.length; i++) {
          const item = this.selectionList[i]
          if (item.feeMasterId != null) {
            this.$message.error('已关联账单的货物不可修改结算客户')
            return
          } else {
            const item0 = this.selectionList[0]
            let selection0 = item.payCustomerName + item.productTypeName + item.feeType
            let row0 = item0.payCustomerName + item0.productTypeName + item0.feeType
            console.log(selection0, row0)
            if (selection0 != row0) {
              this.$message.error('结算客户、货物类型、费用类型相同且未关联账单的货物才可同时修改')
              return
            }
          }
        }
        this.XGvisible = true
        this.KHFormData.payCustomerName = ''
        this.$nextTick(() => {
          this.$refs.KHFormData.clearValidate()
        })
      }
    },
    XGQD () {
      this.$refs.KHFormData.validate((valid) => {
        if (valid) {
          if (this.selectionList[0].payCustomerName == this.KHFormData.payCustomerName) {
            this.$message.error('新结算客户不可与旧结算客户相同')
            return
          }

          this.addLoad = true
          let feeDetailJcIds = Array.from(new Set(this.selectionList.map(item => item.feeDetailJcId))).join(',')
          updateJCPayCustomer({
            feeDetailJcIds,
            payCustomerName: this.KHFormData.payCustomerName,
            payCustomerNameTaxId: this.keHuOptions.filter(item => item.showName == this.KHFormData
              .payCustomerName)[0].itemNo
          }).then(res => {
            console.log(res)
            this.$message.success('修改成功')
            this.chaxun()
            this.selectionList = []
            this.addLoad = false
            this.XGvisible = false
            this.KHFormData.payCustomerName = ''
          })
            .catch(error => {
              this.addLoad = false
              this.$message.error(error.message)
            })
        } else {
          this.addLoad = false
        }
      })
    },
    zidianS () {
      zidian({
        groupNo: 'product_type'
      })
        .then(res => {
          this.productOptions = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.RKData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      console.log(val)
      // let product = this.productTypeData.filter(item => item.productTypeName == val)
      // if (product.length > 0) this.formData.productType = product[0].productType
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val

      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.formData.productType,
        placeOfOrigin: this.formData.placeOfOrigin,
        specification: this.formData.specification,
        model: this.formData.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/costBreakdown')
    this.getQueryCusterData()
    this.getVirtualBalingList()
    this.chaxun()
    this.getRelationCustomerS()
  },
  mounted () {
    this.$nextTick(() => {
      let h = this.$refs.searchBox.offsetHeight
      let pH = document.documentElement.clientHeight
      this.h = pH - h - 200 + 'px'
    })
    getDictionaryJson({
      groupNo: 'jc_overdue_settlement_flag',
      itemNo: localStorage.getItem('tenantCode')
    })
      .then(res => {
        // 是否配置超期费，配置了则不显示预转+清单
        if (res.length !== 0) {
          this.chaoqiFlag = 1
        } else {
          this.chaoqiFlag = 0
        }
      })
      .catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
  }
}

</script>

<style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 0px;
}

  .formBox /deep/ .el-form-item{
  margin-bottom: 6px!important;
}

</style>
